<div id="safety-duo-route-assignment-details"></div>